


































import { defineComponent, ref, watch } from "@vue/composition-api"

export default defineComponent({
  name: 'LearnerActivitiesCalenderHeader',
  props: {
		headerProps: {
			type: Object,
			required: true,
		},
		previousPeriodLabel: { type: String, default: "<" },
		nextPeriodLabel: { type: String, default: ">" }
	},
  emits: ['input', 'period-changed'],
  setup(props, { emit }) {
    const selectedPeriod = ref('month');

    watch(selectedPeriod, (p)=>{
			emit('period-changed', p)
    })

    function onInput(d: Date){
      emit('input', d);
    }

    selectedPeriod.value = 'all';

    return {
      selectedPeriod,
      onInput
    };
  }
})
